import MarcaCrud from './MarcaCrud'
export {MarcaCrud}
export default MarcaCrud
